<template>
    <div>
        <el-dialog :close-on-click-modal="false" title="导入excel文件" append-to-body v-bind="$attrs"  v-on="$listeners">
            <el-form  label-width="120px">
                <el-form-item v-auth="'shangchuanExcelTemplate'" label="上传模板：">
                    <brupload
                            :refid="refId"
                            :reftype="refType"
                            uploadflag
                            delflag
                    />
                </el-form-item>
                <el-form-item label="点击下载模板：">
                    <li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                        <a class="el-upload-list__item-name" v-down="o.id"><i
                                class="el-icon-document"></i>{{o.name}}
                        </a>
                    </li>
                </el-form-item>
                <el-form-item>
                    <el-upload
                            class="upload-demo"
                            action=""
                            :before-upload="beforeUpload"
                            multiple  >
                        <el-button size="small" type="primary">导入EXCEL<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="提示内容："  >
                    <el-input
                        style="width:98%;height:100px;padding: 3px;"
                        type="textarea"
                        :rows="5"
                        v-model="formattedMsg">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="callback">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    import ss from "../../api/SystemService";
    export default {
        props:{
            refid:null,
            reftype:null,
            clsname:null,
            startrow:{
                type: Number,
                default: 0
            },
            extparams:{},
        },
        data(){
          return {
              fileList: [],
              resultdata:null,
              msg:null,
          }
        },
        mounted(){
            uploaddown.listdownfile({refid:this.refId, reftype: this.refType}).then(rd => {
                if(rd.obj && rd.obj.length>0){
                    this.fileList.push(rd.obj[rd.obj.length-1])
                }
            })
        },
        computed: {
            formattedMsg() {
                if (!this.msg) return '';
                return this.msg.replace(/;/g, '\n');
            },
            clsName:function(){
                return this.clsname;
            },
            startRow:function () {
                return this.startrow;
            },
            refId:function () {
                return this.refid||this.clsname;
            },
            refType:function () {
                return this.reftype||this.clsname;
            },
            extParams:function () {
                return this.extparams;
            }
        },
        methods: {
          beforeUpload(file){
            // 先校验提示是不是要审批
            uploaddown.importExcel(file, {clsname: "bscTargetAgainstUserIsSpExcel", startrow: this.startRow,extparams:this.extParams }).then(rd => {
              // 使用 $confirm 替代 $msg
              this.$confirm(rd.msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'custom-confirm-dialog' // 应用自定义样式
              }).then(() => {
                uploaddown.importExcel(file, {clsname: this.clsName, startrow: this.startRow,extparams:this.extParams }).then(rd => {
                  this.resultdata = rd;
                  if(rd.f){
                    this.msg = rd.msg || "导入成功！";
                  }else{
                    this.$message.error("导入出错！");
                    this.msg = rd.msg;
                  }
                }).catch(error=>{
                  return Promise.reject(error);
                })
              }).catch(() => {
                // 用户取消操作
                console.log('用户取消了导入');
              });
            }).catch(error=>{
              return Promise.reject(error);
            })
            return false;
          },
            callback(){
                this.$emit("callback",this.resultdata)
                this.$emit("update:visible",false)
            },
        },
    }
</script>
<style>/* 设置确认对话框的最大高度和滚动 */
.custom-confirm-dialog .el-message-box__message {
  max-height: 300px;
  overflow-y: auto;
  line-height: 1.5;
}

/* 可选：调整对话框整体大小 */
.custom-confirm-dialog {
  max-width: 600px;
}
</style>
